import React from 'react';
import { Chip } from '@mui/material';

export const FONT = 'Mulish, sans-serif';

export const authToken = () => {
  const raw = sessionStorage.getItem('token');
  return raw ? `Bearer ${raw}` : '';
};

export const STATUS = {
  open: { label: 'Open', bg: '#fee2e2', fg: '#991b1b', accent: '#ef4444' },
  'in-progress': { label: 'In progress', bg: '#fef3c7', fg: '#92400e', accent: '#f59e0b' },
  resolved: { label: 'Resolved', bg: '#dcfce7', fg: '#166534', accent: '#22c55e' },
};
export const PRIORITY = {
  low: { label: 'Low', bg: '#f1f5f9', fg: '#475569' },
  normal: { label: 'Normal', bg: '#e0e7ff', fg: '#3730a3' },
  high: { label: 'High', bg: '#ffe4e6', fg: '#9f1239' },
};

export const StatusChip = ({ status }) => {
  const s = STATUS[status] || STATUS.open;
  return <Chip size="small" label={s.label} sx={{ fontFamily: FONT, fontWeight: 700, height: 22, background: s.bg, color: s.fg }} />;
};
export const PriorityChip = ({ priority }) => {
  const p = PRIORITY[priority] || PRIORITY.normal;
  return <Chip size="small" label={p.label} sx={{ fontFamily: FONT, fontWeight: 700, height: 22, background: p.bg, color: p.fg }} />;
};

export const dt = (d) => (d ? new Date(d).toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '—');
export const ago = (d) => {
  if (!d) return '—';
  const mins = Math.floor((Date.now() - new Date(d).getTime()) / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  return days < 30 ? `${days}d ago` : new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
};
export const initial = (name) => (String(name || '?').trim()[0] || '?').toUpperCase();

export const yellowBtn = { textTransform: 'none', fontWeight: 800, background: 'rgb(255 209 2)', color: 'black', borderRadius: '10px', px: 3, boxShadow: '0 4px 12px rgba(255, 209, 2, 0.3)', '&:hover': { background: 'rgb(255 190 0)' } };
